"use client";
import o, { useMemo as l } from "react";
import s from "./index.es41.js";
import "./index.es16.js";
import "./index.es17.js";
import "./index.es18.js";
import "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es27.js";
import "./index.es28.js";
import "./index.es29.js";
import "./index.es30.js";
import "./index.es31.js";
import "./index.es32.js";
import "./index.es33.js";
import "./index.es34.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es37.js";
import "./index.es38.js";
import n from "./index.es42.js";
const I = ({
  data: t,
  options: m,
  content: i,
  id: p,
  parentId: e,
  file: c,
  sheetIndex: r
}) => {
  const a = l(
    () => Array.isArray(t) ? t[r || 0] : t,
    [t, r]
  );
  return /* @__PURE__ */ o.createElement(s, null, /* @__PURE__ */ o.createElement(
    n,
    {
      blockId: `section-${e}-block-${p}`,
      data: a,
      options: m,
      content: i,
      file: c
    }
  ));
};
export {
  I as default
};
//# sourceMappingURL=index.es6.js.map
